import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../../node_modules/axios/index";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { logOut } from "../../../redux/actions/authActions/authAction";
import constatntMessages from "../../../constants/constatntMessages";
import "./org.css";
import { fetchIpAddress } from "../../../helpers/commonHelpers";
import meetingPlusLogo from "../../../assets/images/MinutesPlusVaultLogo1.svg";
import LoginImage from "../../Login/LoginImage";
import Spinner from "react-bootstrap/Spinner";
import validator from "validator";
import { handleApiError } from "../../../helpers/errorResponseHelper";

const OrganizationRegistration = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [otpStatus, setOtpStatus] = useState(false);
  const [otpProcessLoading, setOtpProcessloading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  const [otpVerifyMessage, setOtpVerifyMessage] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(""); // Separate state for OTP

  const [emailError, setEmailError] = useState("");
  const [isValidEmailEntered, setIsValidEmailEntered] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [otpSuccessMessage, setOTPSuccessMessageVal] = useState("");
  const [otpLengthError, setOtpLengthError] = useState("");
  const [otpErrorMessage, setOTPErrorMessageVal] = useState("");
  const [otpError, setOTPError] = useState("");
  const [otpRequire, setOtpRequire] = useState("");
  const [verifyOTPSuccessMessage, setVerifyOTPSuccessMessageVal] = useState("");
  const [verifyOTPErrorMessage, setVerifyOTPErrorMessageVal] = useState("");
  const dispatch = useDispatch();
  const organizationId = userData?.organizationId;
  const accessToken = localStorage.getItem("accessToken");
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    contactPersonName: "",
    phoneNo: "",
    contactPersonPhNo: "",
    contactPersonWhatsAppNo: "",
  });
  const [errors, setErrors] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const fromEditOrg = false;

  const validate = () => {
    let isValid = true;
    let errors = {};
    const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
    const disAlowNumber = /^[a-zA-Z .,:;()/\-_@&$'"#]+$/;

    const phoneNumberRegex = /^[0-9]{10}$/;
    if (!formValues?.name?.trim()) {
      isValid = false;
      errors.name = "Organization Name is Required";
    } else if (!excludeHtml.test(formValues.name)) {
      isValid = false;
      errors.name = constatntMessages.invalidInput;
    } else if (formValues.name.length < 2 || formValues.name.length > 100) {
      isValid = false;
      errors.name = "Name Must be 2-100 Characters";
    }

    if (!formValues?.email?.trim()) {
      isValid = false;
      errors.email = "Email is Required";
    } else if (!validator.isEmail(formValues.email, { require_tld: false })) {
      isValid = false;
      errors.email = "Invalid email format";
    }

    if (!isValid) {
      setErrors(errors);
      return false;
    }

    if (!isOTPVerified) {
      setOtpRequire(constatntMessages.otpBeforeSubmit);
      setTimeout(() => setOtpRequire(""), 6000);
      return false;
    }
    if (formValues?.contactPersonName?.trim()) {
      if (!disAlowNumber.test(formValues.contactPersonName)) {
        isValid = false;
        errors.contactPersonName =
          constatntMessages.invalidInputContactPersonName;
      } else if (
        formValues.contactPersonName.length < 2 ||
        formValues.contactPersonName.length > 70
      ) {
        isValid = false;
        errors.contactPersonName =
          constatntMessages.contactPersonNameValidationCheck;
      }
    }

    if (!formValues?.contactPersonName?.trim()) {
      isValid = false;
      errors.contactPersonName = "Contact PersonName is Required";
    }

    if (!formValues?.phoneNo) {
      isValid = false;
      errors.phoneNo = "Number is Required";
    } else if (!phoneNumberRegex.test(formValues.phoneNo)) {
      isValid = false;
      errors.phoneNo = constatntMessages.phoneNoValidation;
    }

    if (
      formValues?.contactPersonPhNo &&
      !phoneNumberRegex.test(formValues.contactPersonPhNo)
    ) {
      isValid = false;
      errors.contactPersonPhNo = constatntMessages.phoneNoValidation;
    }

    if (
      formValues?.contactPersonWhatsAppNo &&
      !phoneNumberRegex.test(formValues.contactPersonWhatsAppNo)
    ) {
      isValid = false;
      errors.contactPersonWhatsAppNo = constatntMessages.phoneNoValidation;
    }

    setErrors(errors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValue =
      name === "email" ? value.trim().toLowerCase() : value.toString();

    setFormValues({ ...formValues, [name]: updatedValue });

    if (name === "email") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: null,
      }));

      const newErrors = {};

      if (updatedValue === "") {
        newErrors.email = "Email is Required";
        setIsValidEmailEntered(false);
      } else if (!emailPattern.test(updatedValue)) {
        newErrors.email = "Please enter a valid email address.";
        setIsValidEmailEntered(false);
      } else {
        setIsValidEmailEntered(true);
        newErrors.email = "";
      }

      setEmailError(newErrors.email);
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);

    if (e.target.value.toString().length == 6) {
      setOTPError("");
    }
  };

  const handleCreateOrganization = async (e) => {
    e.preventDefault();

    if (validate()) {
      if (!isOTPVerified) {
        setOtpRequire(constatntMessages.otpBeforeSubmit);
        setTimeout(() => setOtpRequire(""), 6000);
      }

      setIsLoading(true);
      setShowConfirmModal(false);
      const formData = new FormData();
      formData.append("name", formValues?.name);
      formData.append("email", formValues?.email);
      formData.append("phoneNo", formValues?.phoneNo);
      formData.append("contactPersonName", formValues.contactPersonName);
      formData.append("contactPersonPhNo", formValues?.contactPersonPhNo);
      formData.append(
        "contactPersonWhatsAppNo",
        formValues?.contactPersonWhatsAppNo
      );
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/V1/organization/createOrganization`,
          formValues,
          {
            headers: {
              Authorization: accessToken,
              ip: await fetchIpAddress(),
            },
          }
        );

        if (response.data.success) {
          setFormValues({
            name: "",
            email: "",
            contactPersonName: "",
            phoneNo: "",
            contactPersonPhNo: "",
            contactPersonWhatsAppNo: "",
          });

          setOtpRequire("");
          setIsOTPVerified(false);

          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate("/login");
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        if (handleApiError(error)) return;
        console.error("Error creating organization:", error);
        toast.error(error.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const nameValidationCheck = () => {
    const newErrors = { ...errors };
    const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;

    const isOnlyNumbers = /^\d+$/;

    if (!formValues?.name || !formValues?.name.trim()) {
      newErrors.name = "Organization Name is Required";
    } else if (isOnlyNumbers.test(formValues.name)) {
      newErrors.name = "Organization Name cannot be only numbers";
    } else if (!excludeHtml.test(formValues.name)) {
      newErrors.name = constatntMessages.invalidInput;
    } else if (formValues.name.length < 3 || formValues.name.length > 100) {
      newErrors.name = "Name Must be 3-100 Characters";
    } else {
      delete newErrors.name;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const phoneNoValidationCheck = () => {
    const newErrors = { ...errors };
    const phoneNumberRegex = /^[0-9]{10}$/;

    if (!formValues?.phoneNo || !formValues.phoneNo) {
      newErrors.phoneNo = "Number is Required";
    } else if (!phoneNumberRegex.test(formValues.phoneNo)) {
      newErrors.phoneNo = constatntMessages.phoneNoValidation;
    } else {
      delete newErrors.phoneNo;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const contactPersonNameValidationCheck = () => {
    const newErrors = { ...errors };
    const excludeHtml = /^[a-zA-Z .,:;()/\-_@&$'"#]+$/; // Removed 0-9

    if (!excludeHtml.test(formValues.contactPersonName)) {
      newErrors.contactPersonName =
        constatntMessages.invalidInputContactPersonName;
    } else if (
      formValues.contactPersonName.length < 2 ||
      formValues.contactPersonName.length > 70
    ) {
      newErrors.contactPersonName =
        constatntMessages.contactPersonNameValidationCheck;
    } else {
      delete newErrors.contactPersonName;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const contactPersonPhoneNoValidationCheck = () => {
    const newErrors = { ...errors };
    const phoneNumberRegex = /^[0-9]{10}$/;

    if (!phoneNumberRegex.test(formValues.contactPersonPhNo)) {
      newErrors.contactPersonPhNo = constatntMessages.phoneNoValidation;
    } else {
      delete newErrors.contactPersonPhNo;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const contactPersonWpNoValidationCheck = () => {
    const newErrors = { ...errors };
    const phoneNumberRegex = /^[0-9]{10}$/;

    if (!phoneNumberRegex.test(formValues.contactPersonWhatsAppNo)) {
      newErrors.contactPersonWhatsAppNo = constatntMessages.phoneNoValidation;
    } else {
      delete newErrors.contactPersonWhatsAppNo;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const emailValidationCheck = () => {
    const newErrors = { ...errors };

    if (!formValues?.email || !formValues.email.trim()) {
      newErrors.email = "Email is Required";
      setIsValidEmailEntered(false);
    } else if (!validator.isEmail(formValues.email, { require_tld: false })) {
      newErrors.email = "Invalid email format";
      setIsValidEmailEntered(false);
    } else {
      delete newErrors.email;
      setIsValidEmailEntered(true);
    }

    setErrors(newErrors);
    return newErrors;
  };

  const otpLengthCheck = () => {
    let isSafeOtpData = true;
    if (!otp) {
      setOTPError("Please enter the OTP.");
      setOtpStatus(false);
      isSafeOtpData = false;
    } else if (otp.toString().length < 6) {
      setOTPError("OTP should be exactly 6 digits.");
      setOtpStatus(false);
      isSafeOtpData = false;
    } else if (otp.toString().length == 6) {
      setOTPError("");
      isSafeOtpData = true;
    }
  };

  useEffect(() => {
    document.title = "Organization: MinutesVault";
    setErrors("");
    setErrors(null);
    setIsValidEmailEntered(false);
    setIsOTPVerified(false);
    setVerifyOTPSuccessMessageVal("");
    setVerifyOTPErrorMessageVal("");
    setOTPSuccessMessageVal("");
    setOTPErrorMessageVal("");
  }, [organizationId]);

  const sendOtp = async (name, email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/organization/sendOtp`,
        { name, email, fromEditOrg }
      );
      return response.data;
    } catch (error) {
      if (handleApiError(error)) return;
      const message =
        error.response?.data?.message || "An unexpected error occurred.";
      return { success: false, error: true, message };
    }
  };

  const verifyOtp = async (email, otp) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/organization/verifyOtp`,
        { email, otp }
      );

      return response.data;
    } catch (error) {
      if (handleApiError(error)) return;
      const message =
        error.response?.data?.message || "An unexpected error occurred.";
      return { success: false, message };
    }
  };

  const handleSendOtp = async () => {
    const newErrors = { ...errors };
    const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
    const isOnlyNumbers = /^\d+$/;

    if (!formValues?.name || !formValues?.name.trim()) {
      newErrors.name = "Organization Name is Required";
    } else if (isOnlyNumbers.test(formValues.name)) {
      newErrors.name = "Organization Name cannot be only numbers";
    } else if (!excludeHtml.test(formValues.name)) {
      newErrors.name = constatntMessages.invalidInput;
    } else if (formValues.name.length < 3 || formValues.name.length > 100) {
      newErrors.name = "Organization Name must be between 3 - 100 characters";
    } else {
      delete newErrors.name;
    }

    if (!formValues?.email || !formValues.email.trim()) {
      newErrors.email = "Email is Required";
    } else if (!validator.isEmail(formValues.email, { require_tld: false })) {
      newErrors.email = "Invalid email format";
    } else {
      delete newErrors.email;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setOtpLoading(true);
    setOtpVerifyMessage("");
    setOTPSuccessMessageVal("");
    setOTPErrorMessageVal("");

    const response = await sendOtp(formValues.name, formValues.email);

    if (response?.success == true) {
      const message = "OTP Has Been Sent To The Entered Email";
      setOtpLoading(false);
      setOtpSent(true);
      setOtp("");
      setOTPSuccessMessageVal(response.message);

      toast.success(response.message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      const message = response?.message || "Unable To Send OTP";
      setOtpLoading(false);
      setOtpSent(false);
      setOtp("");
      setOTPErrorMessageVal(message);
      setTimeout(() => setOTPErrorMessageVal(""), 6000);
      toast.error(response?.message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleVerifyOtp = async () => {
    let isSafeOtpData = true;
    let isSafeEmailData = true;

    const message = "OTP Should Be 6 Digit";

    if (!otp || otp.trim() === "") {
      setOTPError("Please Enter The OTP.");
      setOtpStatus(false);
      isSafeOtpData = false;
    } else if (otp.length !== 6) {
      setOTPError("OTP Should Be Exactly 6 Digits.");
      setOtpStatus(false);
      setOtpLengthError(message);
      isSafeOtpData = false;
    } else {
      setOTPError("");
      setOtpStatus(true);
      setOtpLengthError("");
      isSafeOtpData = true;
    }

    const newErrors = {};
    if (!formValues?.email || formValues.email.trim() === "") {
      newErrors.email = "Email is Required.";
      isSafeEmailData = false;
    } else if (!emailPattern.test(formValues.email)) {
      newErrors.email = "Please Enter A Valid Email Address.";
      isSafeEmailData = false;
    } else {
      newErrors.email = "";
    }
    setEmailError(newErrors.email);

    // Stop if any validation fails
    if (!isSafeOtpData) {
      return;
    }

    setOtpProcessloading(true);
    setVerifyOTPSuccessMessageVal("");
    setVerifyOTPErrorMessageVal("");
    setOTPSuccessMessageVal("");
    setOTPErrorMessageVal("");

    try {
      const response = await verifyOtp(formValues.email, otp);

      if (response?.success) {
        const message = response.message || "OTP Verified Successfully.";
        setOtpProcessloading(false);
        setIsOTPVerified(true);
        setOtpSent(false);
        setOtp("");
        setOTPError("");

        setTimeout(() => {
          setVerifyOTPSuccessMessageVal("");
        }, 6000);
        toast.success(response.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        const message = response.message || "Unable to verify OTP.";
        setOtpProcessloading(false);
        setVerifyOTPErrorMessageVal(message);

        toast.error(response.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      setOtpProcessloading(false);
      setVerifyOTPErrorMessageVal(
        "An unexpected error occurred while verifying OTP."
      );
      setTimeout(() => {
        setVerifyOTPErrorMessageVal("");
      }, 6000);
    }
  };

  const handleKeyDown = (e) => {
    const { name, value } = e.target;
    const invalidKeys = ["e", "E", "+", "-", ".", ","];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }
    if (name === "phoneNo") {
      if (value.length >= 10 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
    if (name === "contactPersonPhNo") {
      if (value.length >= 10 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
    if (name === "contactPersonWhatsAppNo") {
      if (value.length >= 10 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
    if (name === "otp") {
      if (value.length >= 6 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
  };

  const handleClear = () => {
    setFormValues({
      name: "",
      email: "",
      contactPersonName: "",
      phoneNo: "",
      contactPersonPhNo: "",
      contactPersonWhatsAppNo: "",
    });
    setOtpSent(null);
    setOtp("");
    setErrors("");
    setErrors(null);
    setIsValidEmailEntered(false);
    setIsOTPVerified(false);

    setVerifyOTPSuccessMessageVal("");
    setVerifyOTPErrorMessageVal("");
    setOTPSuccessMessageVal("");
    setOTPErrorMessageVal("");
  };
  const hasValues = Object.values(formValues).some(
    (value) => value.trim() !== ""
  );
  return (
    <section className="sign-in organization-update">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="loginform-container by-password abstract-bg">
              <div className="logo-container">
                <Link to="/">
                  <img
                    src={meetingPlusLogo}
                    className="ntspl-logo login-logo"
                    alt="logo"
                  />
                </Link>
              </div>

              <form
                onSubmit={handleCreateOrganization}
                className="organization-form"
              >
                <div className="text">
                  <h4>Organization Registration</h4>
                </div>

                <div className="row">
                  <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 resp-padd-0">
                    <div className="form-group">
                      <div className="pwd-group">
                        <label className="mb-1">
                          Organization Name <span className="imp-field">*</span>
                        </label>
                        <div className="inner-group">
                          <svg
                            id="Capa_1"
                            enable-background="new 0 0 512 512"
                            height="20px"
                            viewBox="0 0 512 512"
                            width="20px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="m482.284 482h-39.573v-467c0-8.284-6.716-15-15-15h-343.423c-8.284 0-15 6.716-15 15v467h-39.572c-8.284 0-15 6.716-15 15s6.716 15 15 15h452.569c8.284 0 15-6.716 15-15s-6.716-15-15.001-15zm-277.415 0v-102.261h102.261v102.261zm132.261 0v-117.261c0-8.284-6.716-15-15-15h-132.261c-8.284 0-15 6.716-15 15v117.261h-75.581v-452h313.423v452z" />
                              <path d="m223.748 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" />
                              <path d="m361.76 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" />
                              <path d="m223.748 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" />
                              <path d="m361.76 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z" />
                            </g>
                          </svg>
                          <input
                            type="text"
                            name="name"
                            placeholder="Enter Organization Name"
                            value={formValues?.name}
                            onChange={handleChange}
                            onKeyUp={nameValidationCheck}
                            autoComplete="off"
                          />
                        </div>
                        {errors?.name && (
                          <span className="error-message">{errors?.name}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="form-group">
                      <div className="pwd-group">
                        <label className="mb-1">
                          Email <span className="imp-field">*</span>
                        </label>
                        <div className="inner-group">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-envelope-at"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z" />
                            <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                          </svg>
                          <input
                            type="text"
                            name="email"
                            onChange={handleChange}
                            value={formValues?.email}
                            onKeyUp={emailValidationCheck}
                            placeholder="Enter Email Address"
                            className={"form-control is-invalid email-org"}
                            autoComplete="off"
                            readOnly={otpSent || isOTPVerified}
                            maxLength="96"
                          />
                        </div>

                        {errors?.email && (
                          <span className="error-message">{errors?.email}</span>
                        )}

                        {!errors?.email &&
                          isValidEmailEntered &&
                          !isOTPVerified && (
                            <button
                              type="button"
                              className="btn btn-primary verify-email get-otp-button"
                              onClick={handleSendOtp}
                            >
                              {otpLoading ? "Sending..." : "Send OTP"}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>

                  {otpSent && (
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <div className="pwd-group">
                          <div className="enter-otp enter-otp-email">
                            <label className="mb-1">
                              Enter OTP <span className="imp-field">*</span>
                            </label>

                            <div className="inner-group">
                              <svg
                                id="Layer_1"
                                viewBox="0 0 96 96"
                                xmlns="http://www.w3.org/2000/svg"
                                data-name="Layer 1"
                                width="20px"
                                height="20px"
                              >
                                <path d="m50.7 94h-34.08a8.51 8.51 0 0 1 -8.5-8.5v-75a8.51 8.51 0 0 1 8.5-8.5h34.08a8.51 8.51 0 0 1 8.5 8.5v24a1 1 0 0 1 -2 0v-24a6.51 6.51 0 0 0 -6.5-6.5h-34.08a6.51 6.51 0 0 0 -6.5 6.5v75a6.51 6.51 0 0 0 6.5 6.5h34.08a6.51 6.51 0 0 0 6.5-6.5v-28.91a1 1 0 0 1 2 0v28.91a8.51 8.51 0 0 1 -8.5 8.5z" />
                                <path d="m41 10.09a1 1 0 0 1 -1-1 1 1 0 0 1 .29-.7 1 1 0 0 1 1.1-.22.87.87 0 0 1 .32.22 1 1 0 0 1 .22.32 1 1 0 0 1 .07.38 1 1 0 0 1 -.29.71 1 1 0 0 1 -.32.22 1.07 1.07 0 0 1 -.39.07z" />
                                <path d="m35.39 10.09h-9a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2z" />
                                <path d="m37.76 87.57h-9a1 1 0 1 1 0-2h9a1 1 0 0 1 0 2z" />
                                <path d="m40.81 66.16a.92.92 0 0 1 -.36-.07 1 1 0 0 1 -.64-.93v-8a11.55 11.55 0 0 1 -7.63-19.71 11.44 11.44 0 0 1 8.15-3.45h36a11.55 11.55 0 0 1 0 23.09h-26.76l-8 8.71a1 1 0 0 1 -.76.36zm-.48-30.16a9.54 9.54 0 0 0 -9.54 9.55 9.55 9.55 0 0 0 9.54 9.54h.48a1 1 0 0 1 1 1v6.51l6.59-7.15a1 1 0 0 1 .73-.32h27.21a9.55 9.55 0 0 0 0-19.09z" />
                                <path d="m41.29 49.46a1 1 0 0 1 -1-1v-5.93a1 1 0 0 1 2 0v5.93a1 1 0 0 1 -1 1z" />
                                <path d="m38.63 48.14a1 1 0 0 1 -.5-1.86l5.13-3a1 1 0 1 1 1 1.74l-5.13 3a1 1 0 0 1 -.5.12z" />
                                <path d="m44 48.14a1 1 0 0 1 -.5-.13l-5.14-3a1 1 0 0 1 1-1.74l5.14 3a1 1 0 0 1 -.5 1.86z" />
                                <path d="m52.65 49.46a1 1 0 0 1 -1-1v-5.93a1 1 0 0 1 2 0v5.93a1 1 0 0 1 -1 1z" />
                                <path d="m50 48.14a1 1 0 0 1 -.87-.5 1 1 0 0 1 .37-1.36l5.13-3a1 1 0 1 1 1 1.74l-5.13 3a1 1 0 0 1 -.5.12z" />
                                <path d="m55.32 48.14a1 1 0 0 1 -.5-.13l-5.14-3a1 1 0 0 1 1-1.74l5.14 3a1 1 0 0 1 -.5 1.86z" />
                                <path d="m64 49.46a1 1 0 0 1 -1-1v-5.93a1 1 0 0 1 2 0v5.93a1 1 0 0 1 -1 1z" />
                                <path d="m61.35 48.14a1 1 0 0 1 -.87-.5 1 1 0 0 1 .37-1.36l5.13-3a1 1 0 0 1 1 1.74l-5.13 3a1 1 0 0 1 -.5.12z" />
                                <path d="m66.68 48.14a1 1 0 0 1 -.5-.13l-5.14-3a1 1 0 0 1 -.36-1.37 1 1 0 0 1 1.32-.33l5.14 3a1 1 0 0 1 -.5 1.86z" />
                                <path d="m75.38 49.46a1 1 0 0 1 -1-1v-5.93a1 1 0 0 1 2 0v5.93a1 1 0 0 1 -1 1z" />
                                <path d="m72.71 48.14a1 1 0 0 1 -.87-.5 1 1 0 0 1 .37-1.36l5.14-3a1 1 0 0 1 1 1.74l-5.14 3a1 1 0 0 1 -.5.12z" />
                                <path d="m78 48.14a1 1 0 0 1 -.5-.13l-5.14-3a1 1 0 0 1 -.36-1.33 1 1 0 0 1 1.36-.37l5.14 3a1 1 0 0 1 .37 1.36 1 1 0 0 1 -.87.47z" />
                              </svg>
                              <input
                                type="number"
                                name="otp"
                                className={`form-control ${
                                  errors?.otp ? "is-invalid" : ""
                                }`}
                                placeholder="Enter OTP"
                                onKeyDown={handleKeyDown}
                                value={otp || ""}
                                onChange={handleOtpChange}
                                onKeyUp={otpLengthCheck}
                              />
                            </div>

                            {errors?.otp && (
                              <span className="error-message">
                                {errors.otp}
                              </span>
                            )}

                            <button
                              disabled={authData.loading}
                              className="btn btn-primary verify-email get-otp-button"
                              type="submit"
                              onClick={handleVerifyOtp}
                              disabled={otpProcessLoading}
                            >
                              {otpProcessLoading
                                ? "Verifying..."
                                : "Verify OTP"}
                            </button>
                          </div>

                          {otpLengthError && (
                            <span className="error-message">
                              {otpLengthError}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {isOTPVerified && (
                    <>
                      <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="form-group resp-padd-0">
                          <div className="pwd-group">
                            <label className="mb-1">
                              Phone Number <span className="imp-field">*</span>
                            </label>
                            <div className="inner-group phone-filed">
                              <svg
                                id="Layer_1"
                                viewBox="0 0 48 48"
                                xmlns="http://www.w3.org/2000/svg"
                                data-name="Layer 1"
                                width="20px"
                                height="20px"
                              >
                                <g fill="none" stroke="#000" stroke-width="3">
                                  <g
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  >
                                    <path d="m25 1a22 22 0 0 1 22 22" />
                                    <path d="m25 5.88889a17.1111 17.1111 0 0 1 17.11111 17.11111" />
                                    <path d="m25 10.77778a12.22221 12.22221 0 0 1 12.22222 12.22222" />
                                    <path d="m25 15.66667a7.33333 7.33333 0 0 1 7.33333 7.33333" />
                                  </g>
                                  <path
                                    d="m14.41471 20.51437q4.58627 5.89475 9.70354 11.34589a3.55028 3.55028 0 0 0 3.89059.86183l3.01351-1.19609a2.55449 2.55449 0 0 1 2.62526.45248l8.26345 7.236a1.80569 1.80569 0 0 1 .24962 2.449l-2.18779 2.76827a6.69684 6.69684 0 0 1 -5.91876 2.51141 6.6969 6.6969 0 0 1 -2.62839-.83254 60.83 60.83 0 0 1 -16.82595-14.03387l-1.84113-2.1875a60.83075 60.83075 0 0 1 -11.32443-18.757 6.6967 6.6967 0 0 1 -.425-2.72415 6.69676 6.69676 0 0 1 3.37868-5.47023l3.06762-1.74337a1.8057 1.8057 0 0 1 2.383.61757l5.9014 9.26393a2.55444 2.55444 0 0 1 .04976 2.66349l-1.63862 2.79764a3.55028 3.55028 0 0 0 .26139 3.97441z"
                                    stroke-miterlimit="10"
                                  />
                                </g>
                              </svg>
                              <input
                                type="number"
                                name="phoneNo"
                                onChange={handleChange}
                                value={formValues?.phoneNo}
                                onKeyDown={handleKeyDown}
                                onKeyUp={phoneNoValidationCheck}
                                autoComplete="off"
                                placeholder="Enter Phone Number"
                              />
                            </div>
                            {errors?.phoneNo && (
                              <span className="error-message">
                                {errors?.phoneNo}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="form-group">
                          <div className="pwd-group">
                            <label className="mb-1">
                              Contact Person Name{" "}
                              <span className="imp-field">*</span>
                            </label>
                            <div className="inner-group">
                              <svg
                                viewBox="-42 0 512 512.001"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20px"
                                height="20px"
                              >
                                <path d="m210.351562 246.632812c33.882813 0 63.21875-12.152343 87.195313-36.128906 23.96875-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.128906 87.195312 23.980469 23.96875 53.316406 36.125 87.191406 36.125zm-65.972656-189.292968c18.394532-18.394532 39.972656-27.335938 65.972656-27.335938 25.996094 0 47.578126 8.941406 65.976563 27.335938 18.394531 18.398437 27.339844 39.980468 27.339844 65.972656 0 26-8.945313 47.578125-27.339844 65.976562-18.398437 18.398438-39.980469 27.339844-65.976563 27.339844-25.992187 0-47.570312-8.945312-65.972656-27.339844-18.398437-18.394531-27.34375-39.976562-27.34375-65.976562 0-25.992188 8.945313-47.574219 27.34375-65.972656zm0 0" />
                                <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.3125-10.339844-7.808594-20.550781-13.375-30.335938-5.769532-10.15625-12.550782-19-20.160157-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.042969 5.339844-10.96875 0-22.085937-1.796876-33.042968-5.339844-11.210938-3.621094-20.300782-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.753906-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.609375 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.0625 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.777344-1.023438 19.953125-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.4375 23.730469 65.066406 23.730469h246.53125c26.621094 0 48.511719-7.984375 65.0625-23.730469 16.757813-15.945312 25.253906-37.589843 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm-44.90625 72.828125c-10.933594 10.40625-25.449218 15.464844-44.378906 15.464844h-246.527344c-18.933594 0-33.449218-5.058594-44.378906-15.460938-10.722656-10.207031-15.933594-24.140625-15.933594-42.585937 0-9.59375.316406-19.066407.949219-28.160157.617187-8.921874 1.878906-18.722656 3.75-29.136718 1.847656-10.285156 4.199219-19.9375 6.996094-28.675782 2.683593-8.378906 6.34375-16.675781 10.882812-24.667968 4.332031-7.617188 9.316407-14.152344 14.816407-19.417969 5.144531-4.925781 11.628906-8.957031 19.269531-11.980469 7.066406-2.796875 15.007812-4.328125 23.628906-4.558594 1.050781.558594 2.921875 1.625 5.953125 3.601563 6.167969 4.019531 13.277344 8.605469 21.136719 13.625 8.859375 5.648437 20.273437 10.75 33.910156 15.152344 13.941406 4.507812 28.160156 6.796875 42.273437 6.796875 14.113282 0 28.335938-2.289063 42.269532-6.792969 13.648437-4.410156 25.058594-9.507813 33.929687-15.164063 8.042969-5.140624 14.953125-9.59375 21.121094-13.617187 3.03125-1.972656 4.902344-3.042969 5.953125-3.601563 8.625.230469 16.566406 1.761719 23.636719 4.558594 7.636719 3.023438 14.121093 7.058594 19.265625 11.980469 5.5 5.261719 10.484375 11.796875 14.816406 19.421875 4.542969 7.988281 8.207031 16.289062 10.886719 24.660156 2.800781 8.75 5.15625 18.398438 7 28.675782 1.867187 10.433593 3.132812 20.238281 3.75 29.144531v.007812c.636719 9.058594.957031 18.527344.960937 28.148438-.003906 18.449219-5.214844 32.378906-15.9375 42.582031zm0 0" />
                              </svg>
                              <input
                                type="text"
                                name="contactPersonName"
                                placeholder="Enter Contact Person Name"
                                value={formValues?.contactPersonName}
                                onChange={handleChange}
                                onKeyUp={contactPersonNameValidationCheck}
                                autoComplete="off"
                              />
                            </div>
                            {errors?.contactPersonName && (
                              <span className="error-message">
                                {errors?.contactPersonName}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="form-group resp-padd-0">
                          <div className="pwd-group">
                            <label className="mb-1">Contact Number</label>
                            <div className="inner-group phone-filed">
                              <svg
                                id="Layer_1"
                                viewBox="0 0 48 48"
                                xmlns="http://www.w3.org/2000/svg"
                                data-name="Layer 1"
                                width="20px"
                                height="20px"
                              >
                                <g fill="none" stroke="#000" stroke-width="3">
                                  <g
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  >
                                    <path d="m25 1a22 22 0 0 1 22 22" />
                                    <path d="m25 5.88889a17.1111 17.1111 0 0 1 17.11111 17.11111" />
                                    <path d="m25 10.77778a12.22221 12.22221 0 0 1 12.22222 12.22222" />
                                    <path d="m25 15.66667a7.33333 7.33333 0 0 1 7.33333 7.33333" />
                                  </g>
                                  <path
                                    d="m14.41471 20.51437q4.58627 5.89475 9.70354 11.34589a3.55028 3.55028 0 0 0 3.89059.86183l3.01351-1.19609a2.55449 2.55449 0 0 1 2.62526.45248l8.26345 7.236a1.80569 1.80569 0 0 1 .24962 2.449l-2.18779 2.76827a6.69684 6.69684 0 0 1 -5.91876 2.51141 6.6969 6.6969 0 0 1 -2.62839-.83254 60.83 60.83 0 0 1 -16.82595-14.03387l-1.84113-2.1875a60.83075 60.83075 0 0 1 -11.32443-18.757 6.6967 6.6967 0 0 1 -.425-2.72415 6.69676 6.69676 0 0 1 3.37868-5.47023l3.06762-1.74337a1.8057 1.8057 0 0 1 2.383.61757l5.9014 9.26393a2.55444 2.55444 0 0 1 .04976 2.66349l-1.63862 2.79764a3.55028 3.55028 0 0 0 .26139 3.97441z"
                                    stroke-miterlimit="10"
                                  />
                                </g>
                              </svg>
                              <input
                                type="number"
                                name="contactPersonPhNo"
                                onChange={handleChange}
                                value={formValues?.contactPersonPhNo}
                                onKeyDown={handleKeyDown}
                                onKeyUp={contactPersonPhoneNoValidationCheck}
                                autoComplete="off"
                                placeholder="Enter Contact Person Mobile No"
                              />
                            </div>
                            {errors?.contactPersonPhNo && (
                              <span className="error-message">
                                {errors?.contactPersonPhNo}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="form-group">
                          <div className="pwd-group">
                            <label className="mb-1">Whatsapp Number</label>
                            <div className="inner-group phone-filed">
                              <svg
                                id="Layer_1"
                                enable-background="new 0 0 512 512"
                                height="20"
                                viewBox="0 0 512 512"
                                width="20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g>
                                  <path d="m437.018 74.98c-48.353-48.352-112.64-74.98-181.02-74.98-.004 0 .002 0-.002 0-68.374 0-132.666 26.631-181.016 74.98-48.351 48.352-74.98 112.639-74.98 181.02.002 43.529 11.08 86.312 32.092 124.152l-31.538 112.808c-1.458 5.217.01 10.815 3.84 14.645s9.426 5.297 14.646 3.84l112.811-31.539c37.836 21.015 80.617 32.093 124.148 32.094 68.381 0 132.668-26.629 181.021-74.981s74.98-112.64 74.98-181.02c-.002-68.381-26.632-132.667-74.982-181.019zm-181.02 407.02c-40.346-.001-79.949-10.773-114.531-31.151-2.329-1.373-4.961-2.077-7.615-2.077-1.354 0-2.712.183-4.039.554l-93.194 26.054 26.054-93.191c1.099-3.93.549-8.137-1.522-11.653-20.378-34.587-31.149-74.193-31.151-114.537 0-60.367 23.508-117.12 66.194-159.806s99.439-66.193 159.804-66.193c124.614 0 225.998 101.383 226.002 225.999 0 124.617-101.384 226.001-226.002 226.001z" />
                                  <path d="m366.507 275.182c-9.169-9.17-21.396-14.22-34.428-14.22s-25.258 5.05-34.425 14.219l-6.954 6.953c-1.715 1.714-4.02 2.659-6.489 2.659-2.471 0-4.776-.945-6.494-2.663l-47.873-47.872c-1.715-1.714-2.659-4.02-2.66-6.491 0-2.471.943-4.775 2.656-6.488l6.956-6.955c18.983-18.983 18.983-49.871.001-68.854l-13.911-13.915c-9.171-9.167-21.397-14.214-34.428-14.214s-25.257 5.048-34.427 14.218l-10.372 10.374c-21.929 21.929-29.889 54.585-22.416 91.955 7.033 35.164 27.136 70.762 56.607 100.236 37.139 37.135 84.439 59.307 126.53 59.31h.008c26.521 0 49.226-8.684 65.655-25.113l10.373-10.373c18.983-18.983 18.983-49.873 0-68.858zm-7.303 61.553-10.373 10.373c-10.682 10.681-26.048 16.326-44.442 16.326-.001 0-.005 0-.005 0-34.312-.002-73.684-18.889-105.319-50.522-25.33-25.332-42.52-55.486-48.403-84.907-5.443-27.217-.396-50.25 14.212-64.859l10.371-10.373c3.503-3.502 8.195-5.431 13.214-5.431 5.021 0 9.715 1.929 13.216 5.429l13.909 13.912c7.286 7.287 7.286 19.142.001 26.428l-6.956 6.955c-7.381 7.38-11.445 17.22-11.444 27.706.001 10.484 4.067 20.323 11.447 27.702l47.873 47.871c7.382 7.384 17.222 11.45 27.707 11.45 10.483 0 20.321-4.065 27.701-11.445l6.955-6.954c3.502-3.503 8.194-5.432 13.212-5.432 5.019 0 9.711 1.929 13.215 5.433l13.909 13.909c7.286 7.285 7.287 19.142 0 26.429z" />
                                </g>
                              </svg>
                              <input
                                type="number"
                                name="contactPersonWhatsAppNo"
                                onChange={handleChange}
                                value={
                                  formValues?.contactPersonWhatsAppNo || ""
                                }
                                onKeyDown={handleKeyDown}
                                onKeyUp={contactPersonWpNoValidationCheck}
                                autoComplete="off"
                                placeholder="Enter Phone Number"
                              />
                            </div>
                            {errors?.contactPersonWhatsAppNo && (
                              <span className="error-message">
                                {errors?.contactPersonWhatsAppNo}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="row">
                  {isLoading ? (
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                      <button className="signin-btn1 org-button" type="button">
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Processing...
                      </button>
                    </div>
                  ) : (
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                      <button className="signin-btn1 org-button" type="submit">
                        Register
                      </button>
                      {otpRequire && (
                        <div className="center-error">
                          <span className="final-error">{otpRequire}</span>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 resp-padd-0">
                    {hasValues && (
                      <button
                        className="signin-btn1 org-button reset-org-btn1"
                        type="button"
                        onClick={handleClear}
                      >
                        Reset
                      </button>
                    )}
                  </div>
                </div>
              </form>
              <div className="backToSignIn-button mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#0b77e8"
                  className="bi bi-arrow-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                  />
                </svg>
                <span>
                  <Link to="/login">Back to Sign In </Link>
                </span>
              </div>
            </div>
          </div>
          <LoginImage />
        </div>
      </div>
    </section>
  );
};

export default OrganizationRegistration;
